var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#globe_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M8.493 1.333A6.663 6.663 0 0 0 1.833 8c0 3.68 2.98 6.667 6.66 6.667A6.67 6.67 0 0 0 15.167 8a6.67 6.67 0 0 0-6.674-6.667m4.62 4h-1.966a10.4 10.4 0 0 0-.92-2.373 5.35 5.35 0 0 1 2.886 2.373M8.5 2.693c.553.8.987 1.687 1.273 2.64H7.227c.286-.953.72-1.84 1.273-2.64m-5.16 6.64A5.5 5.5 0 0 1 3.167 8c0-.46.066-.907.173-1.333h2.253C5.54 7.107 5.5 7.547 5.5 8s.04.893.093 1.333zm.547 1.334h1.966c.214.833.52 1.633.92 2.373a5.32 5.32 0 0 1-2.886-2.373m1.966-5.334H3.887A5.33 5.33 0 0 1 6.773 2.96c-.4.74-.706 1.54-.92 2.373M8.5 13.307a9.4 9.4 0 0 1-1.273-2.64h2.546a9.4 9.4 0 0 1-1.273 2.64m1.56-3.974H6.94c-.06-.44-.107-.88-.107-1.333s.047-.9.107-1.333h3.12c.06.433.107.88.107 1.333s-.047.893-.107 1.333m.167 3.707c.4-.74.706-1.54.92-2.373h1.966a5.35 5.35 0 0 1-2.886 2.373m1.18-3.707c.053-.44.093-.88.093-1.333s-.04-.893-.093-1.333h2.253c.107.426.173.873.173 1.333s-.066.907-.173 1.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "globe_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgGlobe;